import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import './assets/iconmoon/icon/style.css'; 
import './app.scss'; 


import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import Store from "./store";
import MainRoute from './route'
// import reportWebVitals from './reportWebVitals';
import { HashRouter as Router} from 'react-router-dom'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={Store}>
        <Router>
          <MainRoute/>
        </Router>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
